'use client';

import { useNotificationCacheSync } from '@website/hooks/useNotificationCacheSync';

/**
 * Headless component that keeps React Query caches in sync with incoming
 * notifications. Mount once near the root of the authenticated app shell.
 * Renders nothing.
 */
export function NotificationCacheSync(): null {
  useNotificationCacheSync();
  return null;
}
